import React, {Component} from 'react';
import styled from 'styled-components';
import Task from './Task';
import {Droppable} from 'react-beautiful-dnd';

const Container = styled.div`
margin: 20px;
border: 1px solid lightgrey;
border-radius: 2px;
min-width: 250px;
display: flex;
flex-direction: column;
background-color: rgb(255,255,255);
padding: 5px 10px;
`;

const Title = styled.h3`
padding: 8px`;


const Header = styled.label`
display: flex;
flex-direction: column;
justify-content: center;
padding: 8px;
`;


const CreateTask = styled.input`
width: 200px;
padding: 8px;
border: 2.5px solid rgba(255, 255, 255, 0.8);
border-radius: 5px;
text-align: center;
transition: background-color 0.2s ease;
background-color: ${props => (props.isDraggingOver ? 'skyblue' : 'white')};
padding: 11px 15px;
font-size: 16px;
box-shadow: 0 3px 3px rgba(0,0,0,0.16), 0 3px 3px rgba(0,0,0,0.23);
width: 200px;
;
`;

const TaskList = styled.div`
padding: 8px;
transition: background-color 0.2s ease;
background-color: ${props => (props.isDraggingOver ? 'skyblue' : 'white')};
flex-grow: 1;
`;



export default class Column extends Component {

  render() {
    let title;
    if(this.props.column.title) title = <Title>{ this.props.column.title }</Title>


    return (
      <Container>
        {title}
        <Header data-name={this.props.name}>
          <CreateTask data-column-id={this.props.id} onKeyDown={this.props.createTask} type="text" placeholder="add task"/>
        </Header>
        <Droppable droppableId={this.props.column.id}>
        {(provided, snapshot) => (
          <TaskList 
          isDraggingOver={snapshot.isDraggingOver} 
          {...provided.droppableProps} ref={provided.innerRef}> 
            {this.props.tasks.map((task, index) => {
              console.log(task, 'task rendered')
              if(task !== 'No tasks') {
                return <Task key={task.id} task={task.id} content={task.content} index={index}/>;
              }
            }) } 
          {provided.placeholder}
          </TaskList>
          
        )}
        </Droppable>
        
      </Container>
    )
  }
}